// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host { display: contents; }

.cp-drawer {
    position: fixed;
    top: 0; right: 0; bottom: 0;
    width: min(420px, 90vw);
    background: var(--bg-primary, #fff);
    color: var(--text-primary, #222);
    border-left: 1px solid var(--border-color, #e0e0e0);
    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.18);
    z-index: 1250;
    display: flex;
    flex-direction: column;
    transform: translateX(100%);
    transition: transform 0.18s ease;
}
.cp-drawer.open { transform: translateX(0); }

.cp-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-bottom: 1px solid var(--border-color, #e8e8e8);
    background: var(--bg-secondary, #f7f7f7);
    flex-shrink: 0;
}

.cp-home-btn {
    all: unset;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    color: var(--accent-color, #0066cc);
    white-space: nowrap;
}
.cp-home-btn:hover { text-decoration: underline; }

.cp-breadcrumb {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    font-size: 11px;
    color: var(--text-secondary, #888);
}

.cp-crumb {
    all: unset;
    cursor: pointer;
    font-family: monospace;
    font-size: 11px;
    color: var(--accent-color, #0066cc);
}
.cp-crumb:hover { text-decoration: underline; }
.cp-crumb-current { font-family: monospace; color: var(--text-primary, #222); font-weight: 600; }

.cp-close-btn {
    all: unset;
    cursor: pointer;
    font-size: 16px;
    color: var(--text-secondary, #888);
    padding: 2px 4px;
    flex-shrink: 0;
}

.cp-body {
    flex: 1;
    overflow-y: auto;
    padding: 14px 16px;
    font-size: 13px;
    line-height: 1.5;
}

.cp-index-intro {
    font-size: 12px;
    color: var(--text-secondary, #888);
    margin-bottom: 12px;
}

.cp-index-item {
    all: unset;
    display: block;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    padding: 10px 12px;
    margin-bottom: 8px;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 8px;
    background: var(--bg-secondary, #fafafa);
}
.cp-index-item:hover { border-color: var(--accent-color, #0066cc); background: var(--bg-hover, #eef4fb); }

.cp-index-key {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: monospace;
    font-size: 11.5px;
    font-weight: 700;
    color: var(--accent-color, #0066cc);
    margin-bottom: 3px;
}

.cp-index-short {
    font-size: 12.5px;
    color: var(--text-primary, #333);
}

.cp-empty {
    font-size: 12px;
    color: var(--text-secondary, #888);
    font-style: italic;
}

.cp-detail-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.cp-detail-title {
    font-family: monospace;
    font-size: 13px;
    font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/concept-panel.css"],"names":[],"mappings":"AAAA,QAAQ,iBAAiB,EAAE;;AAE3B;IACI,eAAe;IACf,MAAM,EAAE,QAAQ,EAAE,SAAS;IAC3B,uBAAuB;IACvB,mCAAmC;IACnC,gCAAgC;IAChC,mDAAmD;IACnD,2CAA2C;IAC3C,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,gCAAgC;AACpC;AACA,kBAAkB,wBAAwB,EAAE;;AAE5C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qDAAqD;IACrD,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;AACvB;AACA,qBAAqB,0BAA0B,EAAE;;AAEjD;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,mCAAmC;AACvC;AACA,kBAAkB,0BAA0B,EAAE;AAC9C,oBAAoB,sBAAsB,EAAE,gCAAgC,EAAE,gBAAgB,EAAE;;AAEhG;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,8CAA8C;IAC9C,kBAAkB;IAClB,wCAAwC;AAC5C;AACA,uBAAuB,0CAA0C,EAAE,oCAAoC,EAAE;;AAEzG;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[":host { display: contents; }\n\n.cp-drawer {\n    position: fixed;\n    top: 0; right: 0; bottom: 0;\n    width: min(420px, 90vw);\n    background: var(--bg-primary, #fff);\n    color: var(--text-primary, #222);\n    border-left: 1px solid var(--border-color, #e0e0e0);\n    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.18);\n    z-index: 1250;\n    display: flex;\n    flex-direction: column;\n    transform: translateX(100%);\n    transition: transform 0.18s ease;\n}\n.cp-drawer.open { transform: translateX(0); }\n\n.cp-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 14px;\n    border-bottom: 1px solid var(--border-color, #e8e8e8);\n    background: var(--bg-secondary, #f7f7f7);\n    flex-shrink: 0;\n}\n\n.cp-home-btn {\n    all: unset;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--accent-color, #0066cc);\n    white-space: nowrap;\n}\n.cp-home-btn:hover { text-decoration: underline; }\n\n.cp-breadcrumb {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 4px;\n    font-size: 11px;\n    color: var(--text-secondary, #888);\n}\n\n.cp-crumb {\n    all: unset;\n    cursor: pointer;\n    font-family: monospace;\n    font-size: 11px;\n    color: var(--accent-color, #0066cc);\n}\n.cp-crumb:hover { text-decoration: underline; }\n.cp-crumb-current { font-family: monospace; color: var(--text-primary, #222); font-weight: 600; }\n\n.cp-close-btn {\n    all: unset;\n    cursor: pointer;\n    font-size: 16px;\n    color: var(--text-secondary, #888);\n    padding: 2px 4px;\n    flex-shrink: 0;\n}\n\n.cp-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 14px 16px;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.cp-index-intro {\n    font-size: 12px;\n    color: var(--text-secondary, #888);\n    margin-bottom: 12px;\n}\n\n.cp-index-item {\n    all: unset;\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    cursor: pointer;\n    padding: 10px 12px;\n    margin-bottom: 8px;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 8px;\n    background: var(--bg-secondary, #fafafa);\n}\n.cp-index-item:hover { border-color: var(--accent-color, #0066cc); background: var(--bg-hover, #eef4fb); }\n\n.cp-index-key {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-family: monospace;\n    font-size: 11.5px;\n    font-weight: 700;\n    color: var(--accent-color, #0066cc);\n    margin-bottom: 3px;\n}\n\n.cp-index-short {\n    font-size: 12.5px;\n    color: var(--text-primary, #333);\n}\n\n.cp-empty {\n    font-size: 12px;\n    color: var(--text-secondary, #888);\n    font-style: italic;\n}\n\n.cp-detail-title-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.cp-detail-title {\n    font-family: monospace;\n    font-size: 13px;\n    font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
